import React from 'react'
import PropTypes from 'prop-types'
import TrackedLink from './TrackedLink'

const ContactButton = ({ contactByEmail, link, supplierId, trackingKey, className, text }) => {
  return (
    <TrackedLink
      url={contactByEmail ? `mailto:${link}` : link}
      supplierId={supplierId}
      eventType={trackingKey}
      linkClasses={`pro-small button contact-button ${className}`}
      target={contactByEmail ? '_self' : '_blank'}
    >
      {text || 'Contact Us'}
    </TrackedLink>
  )
}

ContactButton.propTypes = {
  contactByEmail: PropTypes.bool,
  link: PropTypes.string.isRequired,
  supplierId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  trackingKey: PropTypes.string.isRequired,
  className: PropTypes.string,
  text: PropTypes.node
}

ContactButton.defaultProps = {
  contactByEmail: false,
  className: '',
  text: null
}

export default ContactButton
